module.exports = __webpack_public_path__ + "img/myAcount.3c7faf83.jpg";